import { BACKEND_URL } from "src/hooks/useMetadata";
import { postAPI } from "src/utils/fetch";
import type { FacetField, FacetValue, FetchFacetsParams } from "../types";

export const FACET_MAX_RESULT = 100;
export const OVERLAY_MAX_RESULT = 1000;

type RawFacetEntry = { field: string; values?: FacetValue[]; facets?: FacetValue[] };
type RawFacetsResponse =
    | RawFacetEntry[]
    | { total?: number; values?: RawFacetEntry[]; facets?: RawFacetEntry[] };

export const fetchFacets = async ({
    instance,
    index,
    filters,
    maxResult = FACET_MAX_RESULT,
}: FetchFacetsParams): Promise<FacetField[]> => {
    const url = new URL(`v1/search/${index}/facets`, BACKEND_URL);
    url.searchParams.set("max_results", String(maxResult));
    const response = await postAPI({
        url: url.toString(),
        instance,
        payload: filters as unknown as Record<string, unknown>[],
    });
    const body: RawFacetsResponse = await response.json();
    const entries = Array.isArray(body) ? body : (body.values ?? body.facets ?? []);
    return entries.map((entry) => ({
        field: entry.field,
        facets: entry.values ?? entry.facets ?? [],
    }));
};
